<template>
  <div class="container">
    <div class="row">
      <div class="col-1">
        <!-- space -->
      </div>
      <div class="col-10 mt-5 text-center">
        <img src="assets/welcome.png" alt="" height="120">
        <br>
        <br>
        <form>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">OPAL CARD 1</label>
            <input class="form-control outline-custom text-center text-white" placeholder="Enter name">
          </div>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">OPAL CARD 1</label>
            <input class="form-control outline-custom text-center text-white" placeholder="Enter name">
          </div>
          <div class="form-group">
            <label class="text-color-custom font-weight-bold">OPAL CARD 1</label>
            <input class="form-control outline-custom text-center text-white" placeholder="Enter name">
          </div>

          <div class="row">
            <div class="col">
              <!-- space  -->
            </div>
            <div class="col text-right">
              <router-link to="/parkingConfirmation" class="btn btn-custom font-weight-bold pl-4 pr-4" tag="button">VALIDATE</router-link>
              <!-- <button type="submit" class="btn btn-custom font-weight-bold">Validate</button> -->
            </div>
          </div>
        </form>
      </div>
      <div class="col-1">
        <!-- space -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PassengersConfirmation"
}
</script>

<style lang="css" scoped>
</style>
